// extracted by mini-css-extract-plugin
export default {"wrapper":"timer_wrapper__MXcFH","finished":"timer_finished__B90Ka","blink":"timer_blink__xy-30"};